export const convertTo12HourFormat = (time: string): string => {
  const [hours, minutes] = time.split(':')
  let hoursInNum = parseInt(hours, 10)
  const minutesInNum = minutes.padStart(2, '0')
  const period: string = hoursInNum >= 12 ? 'PM' : 'AM'

  if (hoursInNum > 12) {
    hoursInNum -= 12
  } else if (hoursInNum === 0) {
    hoursInNum = 12
  }

  return `${hoursInNum}:${minutesInNum} ${period}`
}

export const convertTo24HourFormat = (time: string): string => {
  const [hours, minutes] = time.split(':')
  const hoursInNum = parseInt(hours, 10)
  const minutesInNum = minutes.padStart(2, '0')
  return `${hoursInNum}:${minutesInNum}`
}
